import ContentPillarsEditor from './ContentPillarsEditor';

const SUB_CATEGORIES = {
  '뷰티/패션': ['의류 쇼핑몰/브랜드', '데일리룩/OOTD', '뷰티/코스메틱', '오프라인 뷰티샵', '헤어/네일'],
  '식음료/F&B': ['카페/디저트', '맛집/리뷰', '레시피/홈쿡'],
  '라이프스타일/취미': ['반려동물', '인테리어/홈카기', '독서/감성노트', '브이로그'],
  '스포츠/건강': ['야외 스포츠/피트니스', '다이어트/식단', 'IT/테크'],
  '지식/정보성': ['기가/재테크', '마케팅/교육', 'B2B/SaaS'],
  '비즈니스/브랜드': ['편집샵/셀렉트숍', 'CEO/창업자', '국내 브랜드/기업'],
  '여행/지역': ['국내/해외 여행', '공간/관광안내', '그래픽 디자인/UI'],
  '크리에이티브/아트': ['사진/영상', '카페/공간', '패턴/텍스'],
};

const CATEGORY_ICONS = [
  { name: '뷰티/패션', icon: 'apparel' },
  { name: '식음료/F&B', icon: 'restaurant' },
  { name: '라이프스타일/취미', icon: 'favorite' },
  { name: '스포츠/건강', icon: 'fitness_center' },
  { name: '지식/정보성', icon: 'menu_book' },
  { name: '비즈니스/브랜드', icon: 'business_center' },
  { name: '여행/지역', icon: 'map' },
  { name: '크리에이티브/아트', icon: 'palette' },
  { name: '기타/직접 입력', icon: 'edit_square' },
];

const POST_STYLES = [
  { key: '정보 전달형', desc: '유용한 정보와 팁 위주' },
  { key: '감성/브랜딩형', desc: '분위기와 무드 중심' },
  { key: '후기/리뷰형', desc: '실제 사용 후기 스타일' },
  { key: '이벤트/프로모션형', desc: '할인, 이벤트 안내' },
  { key: '일상/비하인드형', desc: '일상 공유, 비하인드 씬' },
  { key: '교육/노하우형', desc: '전문 지식 전달' },
];

const TONE_OPTIONS = [
  { key: 'FRIENDLY_EMOJI', title: '친근한 이모지 스타일', desc: '반말 혹은 부드러운 말투' },
  { key: 'PROFESSIONAL', title: '신뢰감 있는 전문직', desc: '격식 있는 존댓말 사용' },
  { key: 'HUMOROUS_TREND', title: '유머러스한 트렌드', desc: '최신 밈과 유머 구사' },
];

function ContentSettingsStep({
  contentSettings, setContentSettings,
  hashtags, hashtagInput, setHashtagInput, addHashtag, removeHashtag,
  contentPillars, addContentPillar, removeContentPillar, updateContentPillar,
  aiSuggestionLoading, handleAiProfileSuggestion,
  customPrompt, setCustomPrompt, isCustomPrompt,
  showAdvancedPrompt, setShowAdvancedPrompt,
  saveCustomPrompt, resetCustomPrompt,
}) {
  return (
    <section style={{ marginBottom: '32px' }}>
      <h3 className="text-lg sm:text-2xl font-bold mb-4 sm:mb-6 flex items-center gap-3">
        <span style={{
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          width: '32px', height: '32px', borderRadius: '50%',
          background: '#1313ec', color: 'white', fontSize: '14px'
        }}>2</span>
        콘텐츠 설정
      </h3>

      <div style={{ display: 'flex', flexDirection: 'column', gap: '40px' }}>

        {/* Card 0: 기본 정보 */}
        <div style={{
          background: '#111118', padding: '32px',
          borderRadius: '12px', border: '1px solid #282839'
        }}>
          <div style={{ borderBottom: '1px solid #282839', paddingBottom: '16px', marginBottom: '24px' }}>
            <h4 style={{ fontSize: '18px', fontWeight: '700', display: 'flex', alignItems: 'center', gap: '8px' }}>
              <span style={{ color: '#1313ec' }}>&#127978;</span>
              기본 정보
            </h4>
            <p style={{ fontSize: '13px', color: '#9d9db9', marginTop: '8px' }}>
              AI가 게시물을 생성할 때 참고하는 핵심 정보입니다
            </p>
          </div>

          {/* 상호명 */}
          <div style={{ marginBottom: '24px' }}>
            <span style={{ fontSize: '14px', fontWeight: '600', paddingLeft: '4px', display: 'block', marginBottom: '12px' }}>
              상호명 / 브랜드명
            </span>
            <input
              type="text"
              value={contentSettings.businessName}
              onChange={(e) => setContentSettings({ ...contentSettings, businessName: e.target.value })}
              placeholder="예: 카페모카, 뷰티랩 서울, 홍길동 PT"
              style={{
                width: '100%', height: '48px', padding: '0 16px',
                background: '#1c1c27', border: '1px solid #3b3b54', borderRadius: '12px',
                outline: 'none', fontSize: '14px'
              }}
            />
          </div>

          {/* 홍보 목표 */}
          <div style={{ marginBottom: '24px' }}>
            <span style={{ fontSize: '14px', fontWeight: '600', paddingLeft: '4px', display: 'block', marginBottom: '12px' }}>
              홍보하고자 하는 내용
            </span>
            <textarea
              value={contentSettings.promotionGoal}
              onChange={(e) => setContentSettings({ ...contentSettings, promotionGoal: e.target.value })}
              placeholder="예: 강남역 근처 디저트 카페 홍보, 신메뉴 출시 알리기, 네일아트 시술 예약 유도"
              rows={3}
              style={{
                width: '100%', padding: '12px 16px',
                background: '#1c1c27', border: '1px solid #3b3b54', borderRadius: '12px',
                outline: 'none', fontSize: '14px', resize: 'vertical', lineHeight: '1.5'
              }}
            />
          </div>

          {/* AI 추천 버튼 */}
          <div style={{
            marginBottom: '24px', padding: '16px 20px',
            background: 'linear-gradient(135deg, rgba(19,19,236,0.08), rgba(99,99,255,0.05))',
            borderRadius: '12px', border: '1px dashed rgba(19,19,236,0.3)',
            display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '16px'
          }}>
            <div>
              <p style={{ fontSize: '14px', fontWeight: '600', marginBottom: '4px' }}>
                <span className="material-symbols-outlined" style={{ fontSize: '16px', verticalAlign: 'middle', marginRight: '6px', color: '#1313ec' }}>auto_awesome</span>
                작성이 어려우시면 AI가 도와드려요
              </p>
              <p style={{ fontSize: '12px', color: '#9d9db9' }}>
                상호명과 업종을 기반으로 홍보 목표, 게시물 성향, 타겟 고객을 자동 추천합니다
              </p>
            </div>
            <button
              onClick={handleAiProfileSuggestion}
              disabled={aiSuggestionLoading}
              style={{
                padding: '10px 20px',
                background: aiSuggestionLoading ? '#3b3b54' : '#1313ec',
                color: '#fff', border: 'none', borderRadius: '10px',
                fontSize: '13px', fontWeight: '600',
                cursor: aiSuggestionLoading ? 'not-allowed' : 'pointer',
                whiteSpace: 'nowrap',
                display: 'flex', alignItems: 'center', gap: '6px', transition: 'all 0.2s'
              }}
            >
              {aiSuggestionLoading ? (
                <>
                  <span className="material-symbols-outlined" style={{ fontSize: '16px', animation: 'spin 1s linear infinite' }}>progress_activity</span>
                  생성 중...
                </>
              ) : (
                <>
                  <span className="material-symbols-outlined" style={{ fontSize: '16px' }}>auto_awesome</span>
                  AI로 추천받기
                </>
              )}
            </button>
          </div>

          {/* 게시물 성향 */}
          <div>
            <span style={{ fontSize: '14px', fontWeight: '600', paddingLeft: '4px', display: 'block', marginBottom: '12px' }}>
              게시물 성향
            </span>
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '10px' }}>
              {POST_STYLES.map(style => {
                const selected = contentSettings.postStyle === style.key;
                return (
                  <div
                    key={style.key}
                    onClick={() => setContentSettings({ ...contentSettings, postStyle: style.key })}
                    style={{
                      padding: '10px 16px', borderRadius: '12px', fontSize: '13px', cursor: 'pointer',
                      border: `1px solid ${selected ? '#1313ec' : '#3b3b54'}`,
                      background: selected ? 'rgba(19,19,236,0.1)' : 'transparent',
                      color: selected ? '#1313ec' : 'inherit', transition: 'all 0.2s', minWidth: '140px'
                    }}
                  >
                    <p style={{ fontWeight: '600', marginBottom: '2px' }}>{style.key}</p>
                    <p style={{ fontSize: '11px', color: selected ? '#6b6bff' : '#9d9db9' }}>{style.desc}</p>
                  </div>
                );
              })}
            </div>
          </div>
        </div>

        {/* Card: 브랜드 상세 정보 */}
        <div style={{
          background: '#111118', padding: '32px',
          borderRadius: '12px', border: '1px solid #282839'
        }}>
          <div style={{ borderBottom: '1px solid #282839', paddingBottom: '16px', marginBottom: '24px' }}>
            <h4 style={{ fontSize: '18px', fontWeight: '700', display: 'flex', alignItems: 'center', gap: '8px' }}>
              <span style={{ color: '#1313ec' }}>&#128230;</span>
              브랜드 상세 정보
            </h4>
            <p style={{ fontSize: '12px', color: '#9d9db9', marginTop: '4px' }}>AI가 더 정확한 콘텐츠를 생성하기 위한 추가 정보입니다</p>
          </div>

          <div style={{ marginBottom: '24px' }}>
            <label style={{ display: 'block', fontSize: '14px', fontWeight: '600', paddingLeft: '4px', marginBottom: '8px' }}>
              주요 상품/서비스
            </label>
            <input
              type="text"
              value={contentSettings.keyProducts}
              onChange={(e) => setContentSettings({ ...contentSettings, keyProducts: e.target.value })}
              placeholder="예: 수제 빵, 케이크, 커피"
              style={{
                width: '100%', paddingLeft: '16px', paddingRight: '16px', height: '56px',
                background: '#1c1c27', border: '1px solid #3b3b54', borderRadius: '12px',
                outline: 'none', fontSize: '16px'
              }}
            />
          </div>

          <div style={{ marginBottom: '24px' }}>
            <label style={{ display: 'block', fontSize: '14px', fontWeight: '600', paddingLeft: '4px', marginBottom: '8px' }}>
              핵심 가치
            </label>
            <input
              type="text"
              value={contentSettings.coreValue}
              onChange={(e) => setContentSettings({ ...contentSettings, coreValue: e.target.value })}
              placeholder="예: 정성 가득 수제, 건강한 재료"
              style={{
                width: '100%', paddingLeft: '16px', paddingRight: '16px', height: '56px',
                background: '#1c1c27', border: '1px solid #3b3b54', borderRadius: '12px',
                outline: 'none', fontSize: '16px'
              }}
            />
          </div>

          <div>
            <label style={{ display: 'block', fontSize: '14px', fontWeight: '600', paddingLeft: '4px', marginBottom: '8px' }}>
              콘텐츠 비율
            </label>
            <input
              type="text"
              value={contentSettings.contentRatio}
              onChange={(e) => setContentSettings({ ...contentSettings, contentRatio: e.target.value })}
              placeholder="예: 일상:50,홍보:30,이벤트:20"
              style={{
                width: '100%', paddingLeft: '16px', paddingRight: '16px', height: '56px',
                background: '#1c1c27', border: '1px solid #3b3b54', borderRadius: '12px',
                outline: 'none', fontSize: '16px'
              }}
            />
            <p style={{ marginTop: '8px', fontSize: '12px', color: '#9d9db9', paddingLeft: '4px' }}>
              콘텐츠 종류별 비율을 설정하세요 (합계 100)
            </p>
          </div>
        </div>

        {/* Card: 게시글 기본 양식 */}
        <div style={{
          background: '#111118', padding: '32px',
          borderRadius: '12px', border: '1px solid #282839'
        }}>
          <div style={{ borderBottom: '1px solid #282839', paddingBottom: '16px', marginBottom: '24px' }}>
            <h4 style={{ fontSize: '18px', fontWeight: '700', display: 'flex', alignItems: 'center', gap: '8px' }}>
              <span style={{ color: '#1313ec' }}>&#9999;&#65039;</span>
              게시글 기본 양식
            </h4>
            <p style={{ fontSize: '12px', color: '#9d9db9', marginTop: '4px' }}>
              기본 캡션은 모든 게시글 첫머리에 자동으로 추가되고, 그 뒤에 AI 생성 내용이 붙습니다
            </p>
          </div>

          <div style={{ marginBottom: '24px' }}>
            <label style={{ display: 'block', fontSize: '14px', fontWeight: '600', paddingLeft: '4px', marginBottom: '8px' }}>
              기본 캡션
            </label>
            <textarea
              value={contentSettings.defaultCaption}
              onChange={(e) => setContentSettings({ ...contentSettings, defaultCaption: e.target.value })}
              placeholder="모든 게시글 첫머리에 자동으로 들어갈 기본 문구를 입력하세요..."
              style={{
                width: '100%', padding: '16px', minHeight: '120px',
                background: '#1c1c27', border: '1px solid #3b3b54', borderRadius: '12px',
                outline: 'none', resize: 'none', fontSize: '14px'
              }}
            />
            <p style={{ marginTop: '8px', fontSize: '12px', color: '#9d9db9', paddingLeft: '4px' }}>
              이 내용이 먼저 표시되고, AI가 생성한 캡션이 그 뒤에 추가됩니다
            </p>
          </div>

          {/* 상시 해시태그 */}
          <div>
            <span style={{ fontSize: '14px', fontWeight: '600', paddingLeft: '4px', display: 'block', marginBottom: '8px' }}>
              기본 해시태그
            </span>
            <div style={{
              minHeight: '56px', padding: '8px',
              background: '#1c1c27', border: '1px solid #3b3b54', borderRadius: '12px',
              display: 'flex', flexWrap: 'wrap', gap: '8px', alignItems: 'center'
            }}>
              {hashtags.map((tag, index) => (
                <span
                  key={index}
                  style={{
                    background: 'rgba(19, 19, 236, 0.2)', color: '#1313ec',
                    padding: '4px 12px', borderRadius: '9999px', fontSize: '14px',
                    fontWeight: '500', display: 'flex', alignItems: 'center', gap: '4px'
                  }}
                >
                  #{tag}
                  <button
                    onClick={() => removeHashtag(tag)}
                    style={{ background: 'none', border: 'none', cursor: 'pointer', fontSize: '12px', color: '#1313ec', padding: 0 }}
                  >
                    ✕
                  </button>
                </span>
              ))}
              <input
                type="text"
                value={hashtagInput}
                onChange={(e) => setHashtagInput(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === 'Enter' && !e.nativeEvent.isComposing) {
                    e.preventDefault();
                    addHashtag();
                  }
                }}
                placeholder="해시태그 추가..."
                style={{ background: 'transparent', border: 'none', outline: 'none', fontSize: '14px', flex: 1, minWidth: '120px' }}
              />
            </div>
            <p style={{ marginTop: '8px', fontSize: '12px', color: '#9d9db9', paddingLeft: '4px' }}>
              기본 해시태그가 먼저 표시되고, AI가 생성한 해시태그가 뒤에 추가됩니다 (Enter로 추가)
            </p>
          </div>
        </div>

        {/* 상세 설정 구분선 */}
        <div style={{ display: 'flex', alignItems: 'center', gap: '16px', margin: '8px 0' }}>
          <div style={{ flex: 1, height: '1px', background: '#282839' }} />
          <span style={{ fontSize: '13px', color: '#9d9db9', fontWeight: '600', whiteSpace: 'nowrap' }}>상세 설정</span>
          <div style={{ flex: 1, height: '1px', background: '#282839' }} />
        </div>

        {/* Card 1: 브랜드/계정 아이덴티티 */}
        <div style={{
          background: '#111118', padding: '32px',
          borderRadius: '12px', border: '1px solid #282839'
        }}>
          <div style={{ borderBottom: '1px solid #282839', paddingBottom: '16px', marginBottom: '24px' }}>
            <h4 style={{ fontSize: '18px', fontWeight: '700', display: 'flex', alignItems: 'center', gap: '8px' }}>
              <span style={{ color: '#1313ec' }}>&#128100;</span>
              브랜드/계정 아이덴티티
            </h4>
          </div>

          {/* STEP 1. 계정 카테고리 */}
          <div style={{ marginBottom: '24px' }}>
            <span style={{ fontSize: '14px', fontWeight: '600', paddingLeft: '4px', display: 'block', marginBottom: '16px' }}>
              STEP 1. 계정 카테고리
            </span>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(5, 1fr)', gap: '12px' }}>
              {CATEGORY_ICONS.map(cat => (
                <div
                  key={cat.name}
                  onClick={() => setContentSettings({
                    ...contentSettings,
                    accountCategory: cat.name,
                    accountSubCategory: ''
                  })}
                  style={{
                    padding: '16px 8px',
                    border: `1px solid ${contentSettings.accountCategory === cat.name ? '#1313ec' : '#3b3b54'}`,
                    borderRadius: '12px', textAlign: 'center', fontSize: '13px', cursor: 'pointer',
                    background: contentSettings.accountCategory === cat.name ? 'rgba(19,19,236,0.1)' : 'transparent',
                    color: contentSettings.accountCategory === cat.name ? '#1313ec' : 'inherit',
                    transition: 'all 0.2s',
                    display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '8px'
                  }}
                >
                  <span className="material-symbols-outlined" style={{ fontSize: '28px' }}>{cat.icon}</span>
                  <span>{cat.name}</span>
                </div>
              ))}
            </div>
          </div>

          {/* STEP 2. 세부 카테고리 */}
          {contentSettings.accountCategory && (
            <div style={{ marginBottom: '24px' }}>
              <span style={{ fontSize: '14px', fontWeight: '600', paddingLeft: '4px', display: 'block', marginBottom: '16px' }}>
                STEP 2. 세부 카테고리
              </span>
              {contentSettings.accountCategory === '기타/직접 입력' ? (
                <input
                  type="text"
                  value={contentSettings.accountSubCategory}
                  onChange={(e) => setContentSettings({ ...contentSettings, accountSubCategory: e.target.value })}
                  placeholder="직접 입력해 주세요"
                  style={{
                    width: '100%', height: '48px', padding: '0 16px',
                    background: '#1c1c27', border: '1px solid #3b3b54', borderRadius: '12px',
                    outline: 'none', fontSize: '14px'
                  }}
                />
              ) : (
                <div style={{ display: 'flex', flexWrap: 'wrap', gap: '10px' }}>
                  {(SUB_CATEGORIES[contentSettings.accountCategory] || []).map(sub => {
                    const selected = contentSettings.accountSubCategory
                      ? contentSettings.accountSubCategory.split(',').includes(sub)
                      : false;
                    return (
                      <div
                        key={sub}
                        onClick={() => {
                          const current = contentSettings.accountSubCategory
                            ? contentSettings.accountSubCategory.split(',').filter(s => s)
                            : [];
                          const updated = selected
                            ? current.filter(s => s !== sub)
                            : [...current, sub];
                          setContentSettings({
                            ...contentSettings,
                            accountSubCategory: updated.join(',')
                          });
                        }}
                        style={{
                          padding: '8px 16px', borderRadius: '20px', fontSize: '13px', cursor: 'pointer',
                          border: `1px solid ${selected ? '#1313ec' : '#3b3b54'}`,
                          background: selected ? '#1313ec' : 'transparent',
                          color: selected ? '#fff' : 'inherit', transition: 'all 0.2s'
                        }}
                      >
                        {sub}
                      </div>
                    );
                  })}
                </div>
              )}
            </div>
          )}

          {/* 타겟 고객 + 톤앤매너 (2열) */}
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '32px' }}>
            {/* 타겟 고객 */}
            <div>
              <span style={{ fontSize: '14px', fontWeight: '600', paddingLeft: '4px', display: 'block', marginBottom: '16px' }}>
                타겟 고객
              </span>
              <div style={{ display: 'flex', gap: '8px', marginBottom: '12px' }}>
                <select
                  value={contentSettings.targetAgeGroup}
                  onChange={(e) => setContentSettings({ ...contentSettings, targetAgeGroup: e.target.value })}
                  style={{
                    width: '50%', height: '48px', padding: '0 16px',
                    background: '#1c1c27', border: '1px solid #3b3b54', borderRadius: '12px',
                    outline: 'none', fontSize: '14px', color: 'inherit'
                  }}
                >
                  <option value="">연령대 선택</option>
                  <option value="10대">10대</option>
                  <option value="2030대">2030대</option>
                  <option value="4050대">4050대</option>
                  <option value="전체">전체</option>
                </select>
                <select
                  value={contentSettings.targetGender}
                  onChange={(e) => setContentSettings({ ...contentSettings, targetGender: e.target.value })}
                  style={{
                    width: '50%', height: '48px', padding: '0 16px',
                    background: '#1c1c27', border: '1px solid #3b3b54', borderRadius: '12px',
                    outline: 'none', fontSize: '14px', color: 'inherit'
                  }}
                >
                  <option value="">성별 선택</option>
                  <option value="여성">여성</option>
                  <option value="남성">남성</option>
                  <option value="무관">무관</option>
                </select>
              </div>
              <input
                type="text"
                value={contentSettings.targetInterest}
                onChange={(e) => setContentSettings({ ...contentSettings, targetInterest: e.target.value })}
                placeholder="주요 관심사 (예: 직장인 여성, 카페 투어)"
                style={{
                  width: '100%', height: '48px', padding: '0 16px',
                  background: '#1c1c27', border: '1px solid #3b3b54', borderRadius: '12px',
                  outline: 'none', fontSize: '14px'
                }}
              />
            </div>

            {/* 톤앤매너 */}
            <div>
              <span style={{ fontSize: '14px', fontWeight: '600', paddingLeft: '4px', display: 'block', marginBottom: '16px' }}>
                톤앤매너
              </span>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                {TONE_OPTIONS.map(tone => (
                  <div
                    key={tone.key}
                    onClick={() => setContentSettings({ ...contentSettings, toneAndManner: tone.key })}
                    style={{
                      padding: '14px 16px',
                      border: `1px solid ${contentSettings.toneAndManner === tone.key ? '#1313ec' : '#3b3b54'}`,
                      borderRadius: '12px', cursor: 'pointer',
                      background: contentSettings.toneAndManner === tone.key ? 'rgba(19,19,236,0.1)' : 'transparent',
                      transition: 'all 0.2s'
                    }}
                  >
                    <p style={{ fontWeight: '700', fontSize: '14px', marginBottom: '4px' }}>{tone.title}</p>
                    <p style={{ fontSize: '11px', color: '#9d9db9' }}>{tone.desc}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* Card 2: 비주얼 가이드 */}
        <div style={{
          background: '#111118', padding: '32px',
          borderRadius: '12px', border: '1px solid #282839'
        }}>
          <div style={{ borderBottom: '1px solid #282839', paddingBottom: '16px', marginBottom: '24px' }}>
            <h4 style={{ fontSize: '18px', fontWeight: '700', display: 'flex', alignItems: 'center', gap: '8px' }}>
              <span style={{ color: '#1313ec' }}>&#127912;</span>
              비주얼 가이드
            </h4>
          </div>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '32px' }}>
            <div>
              <span style={{ fontSize: '14px', fontWeight: '600', paddingLeft: '4px', display: 'block', marginBottom: '16px' }}>
                브랜드 컬러
              </span>
              <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                <input
                  type="color"
                  value={contentSettings.brandColor}
                  onChange={(e) => setContentSettings({ ...contentSettings, brandColor: e.target.value.toUpperCase() })}
                  style={{
                    width: '48px', height: '48px', borderRadius: '8px',
                    border: 'none', background: 'transparent', cursor: 'pointer', padding: 0
                  }}
                />
                <input
                  type="text"
                  value={contentSettings.brandColor}
                  onChange={(e) => setContentSettings({ ...contentSettings, brandColor: e.target.value.toUpperCase() })}
                  placeholder="#HEXCODE"
                  style={{
                    flex: 1, height: '48px', padding: '0 16px',
                    background: '#1c1c27', border: '1px solid #3b3b54', borderRadius: '12px',
                    outline: 'none', fontSize: '14px', fontFamily: 'monospace'
                  }}
                />
              </div>
            </div>

            <div>
              <span style={{ fontSize: '14px', fontWeight: '600', paddingLeft: '4px', display: 'block', marginBottom: '16px' }}>
                선호하는 이미지 무드
              </span>
              <select
                value={contentSettings.imageMood}
                onChange={(e) => setContentSettings({ ...contentSettings, imageMood: e.target.value })}
                style={{
                  width: '100%', height: '48px', padding: '0 16px',
                  background: '#1c1c27', border: '1px solid #3b3b54', borderRadius: '12px',
                  outline: 'none', fontSize: '14px', color: 'inherit'
                }}
              >
                <option value="">무드 선택</option>
                <option value="Minimal">Minimal (심플한)</option>
                <option value="Colorful">Colorful (색감이 화려한)</option>
                <option value="Vintage">Vintage (감성적인)</option>
                <option value="High-res Realistic">High-res Realistic (고화질 실사)</option>
                <option value="Illustration">Illustration (일러스트)</option>
              </select>
            </div>
          </div>
        </div>

        {/* Card 3: 콘텐츠 필러 */}
        <ContentPillarsEditor
          contentPillars={contentPillars}
          addContentPillar={addContentPillar}
          removeContentPillar={removeContentPillar}
          updateContentPillar={updateContentPillar}
        />

        {/* Card 6: 고급 설정 - 프롬프트 커스텀 */}
        <div style={{
          background: '#111118', borderRadius: '12px',
          border: '1px solid #282839', overflow: 'hidden'
        }}>
          <div
            onClick={() => setShowAdvancedPrompt(!showAdvancedPrompt)}
            style={{
              padding: '20px 32px', cursor: 'pointer',
              display: 'flex', justifyContent: 'space-between', alignItems: 'center'
            }}
          >
            <h4 style={{ fontSize: '18px', fontWeight: '700', display: 'flex', alignItems: 'center', gap: '8px', margin: 0 }}>
              <span style={{ color: '#1313ec' }}>&#9881;&#65039;</span>
              고급 설정: AI 프롬프트 커스텀
              {isCustomPrompt && (
                <span style={{
                  fontSize: '11px', background: 'rgba(19,19,236,0.2)', color: '#1313ec',
                  padding: '2px 8px', borderRadius: '9999px', fontWeight: '600'
                }}>커스텀 적용 중</span>
              )}
            </h4>
            <span style={{ color: '#9d9db9', fontSize: '20px', transition: 'transform 0.2s', transform: showAdvancedPrompt ? 'rotate(180deg)' : 'rotate(0)' }}>
              &#9660;
            </span>
          </div>

          {showAdvancedPrompt && (
            <div style={{ padding: '0 32px 32px' }}>
              <div style={{
                background: 'rgba(19,19,236,0.05)', border: '1px solid rgba(19,19,236,0.2)',
                borderRadius: '8px', padding: '12px 16px', marginBottom: '16px', fontSize: '13px', color: '#9d9db9'
              }}>
                관리자가 설정한 기본 프롬프트가 적용됩니다. 직접 수정하면 이 계정에만 커스텀 프롬프트가 적용됩니다.
                <br />사용 가능 변수: {'{Account_Name}'}, {'{Category}'}, {'{Target_Audience}'}, {'{Key_Products}'}, {'{Core_Value}'}, {'{Visual_Mood}'}, {'{Voice_&_Tone}'}, {'{Content_Ratio}'}, {'{Feed_Count}'}, {'{Brand_Color}'}, {'{Permanent_Tags}'}
              </div>

              <textarea
                value={customPrompt}
                onChange={(e) => setCustomPrompt(e.target.value)}
                maxLength={10000}
                style={{
                  width: '100%', padding: '16px', minHeight: '300px',
                  background: '#1c1c27', border: '1px solid #3b3b54', borderRadius: '12px',
                  outline: 'none', resize: 'vertical', fontSize: '13px',
                  fontFamily: 'monospace', lineHeight: '1.6'
                }}
              />
              <div style={{ display: 'flex', gap: '12px', marginTop: '12px', justifyContent: 'flex-end' }}>
                {isCustomPrompt && (
                  <button
                    onClick={resetCustomPrompt}
                    style={{
                      padding: '10px 20px', background: '#282839', color: '#9d9db9',
                      border: '1px solid #3b3b54', borderRadius: '8px', cursor: 'pointer', fontSize: '14px'
                    }}
                  >
                    기본값으로 복원
                  </button>
                )}
                <button
                  onClick={saveCustomPrompt}
                  style={{
                    padding: '10px 20px', background: '#1313ec', color: 'white',
                    border: 'none', borderRadius: '8px', cursor: 'pointer', fontSize: '14px', fontWeight: '600'
                  }}
                >
                  프롬프트 저장
                </button>
              </div>
            </div>
          )}
        </div>

      </div>
    </section>
  );
}

export default ContentSettingsStep;
